module.exports = __webpack_public_path__ + "static/media/reverse_engineering.be4c5e70.jpg";